<div
  class="w-full h-screen rounded-xl border-[#D9D9D9] pt-8 lg:pt-15 px-2 lg:px-5 mb-4 mb-md-0"
  style="
    background: linear-gradient(135deg, #006767 0%, #0a8f8f 45%, #e6f5f5 100%);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  "
>
  <div class="w-full md:w-1/2 bg-white mt-6 lg:mt-10 mx-auto rounded-xl">
    <router-outlet></router-outlet>
  </div>
</div>